import React, { useEffect, useState } from "react";
import { mergeDecrypted } from "../../utils/decrypt";
import {
  Table,
  Button,
  Input,
  Space,
  Typography,
  Tag,
  Alert,
  Row,
  Col,
  Card,
  Modal,
  message,
  Tooltip,
} from "antd";
import { Search, Upload, Eye, FileText } from "lucide-react";
import { useNavigate } from "react-router-dom";
import useRequest from "../../hooks/useRequest";
import apiPath from "../../constants/apiPath";

const { Title, Text } = Typography;

const InvoicePage = () => {
  const navigate = useNavigate();
  const { request } = useRequest();
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [searchText, setSearchText] = useState("");
  const [summary, setSummary] = useState(null);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const normalizePayload = (data) => {
    const payload = data?.data ?? data;
    if (Array.isArray(payload)) return payload;
    return payload?.orders ?? payload?.results ?? payload?.data ?? [];
  };

  const formatMoney = (value) => {
    const numeric = Number(value);
    return Number.isFinite(numeric) ? numeric.toFixed(2) : "0.00";
  };

  const formatDate = (dateString) => {
    if (!dateString || dateString === "-") return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const getStatusColor = (status) => {
    const statusLower = status?.toLowerCase();
    switch (statusLower) {
      case "paid":
      case "completed":
      case "delivered":
        return "#10b981";
      case "pending":
        return "#f59e0b";
      case "cancelled":
        return "#ef4444";
      case "processing":
        return "#3b82f6";
      default:
        return "#94a3b8";
    }
  };

  const getStatusText = (status) => {
    return status?.charAt(0).toUpperCase() + status?.slice(1) || "Pending";
  };

  useEffect(() => {
    fetchInvoices();
  }, []);

  //   const fetchInvoices = () => {
  //     setLoading(true);
  //     request({
  //       url: apiPath.orders,
  //       method: "GET",
  //       onSuccess: async (response) => {
  //         const orders = normalizePayload(response);
  //         console.log(orders);

  //         // Calculate summary statistics
  //         const totalInvoices = orders.length;
  //         const totalRevenue = orders.reduce((sum, order) => {
  //           const amount = Number(
  //             order.total_amount ??
  //               order.grand_total ??
  //               order.total ??
  //               order.amount ??
  //               order.subtotal ??
  //               0,
  //           );
  //           return sum + amount;
  //         }, 0);

  //         const paidInvoices = orders.filter((order) => {
  //           const status = (
  //             order.status ||
  //             order.order_status ||
  //             order.payment_status ||
  //             ""
  //           ).toLowerCase();
  //           return (
  //             status === "paid" ||
  //             status === "completed" ||
  //             status === "delivered"
  //           );
  //         }).length;

  //         const pendingInvoices = orders.filter((order) => {
  //           const status = (
  //             order.status ||
  //             order.order_status ||
  //             order.payment_status ||
  //             ""
  //           ).toLowerCase();
  //           return status === "pending" || status === "processing";
  //         }).length;

  //         setSummary({
  //           total_invoices: totalInvoices,
  //           total_revenue: totalRevenue,
  //           paid: paidInvoices,
  //           pending: pendingInvoices,
  //         });

  //         const rows = orders.map((order, index) => ({
  //           key: order.id ?? order.order_number ?? index,
  //           originalIndex: index,
  //           id: order.id ?? order.order_number ?? index + 1,
  //           orderId: order.order_number ?? order.id ?? `#${index + 1}`,
  //           grandTotal: formatMoney(
  //             order.total_amount ??
  //               order.grand_total ??
  //               order.total ??
  //               order.amount ??
  //               order.subtotal ??
  //               0,
  //           ),
  //           status:
  //             order.status ||
  //             order.order_status ||
  //             order.payment_status ||
  //             "Pending",
  //           orderDate: formatDate(
  //             order.created_at || order.order_date || order.date,
  //           ),
  //           customerName:
  //             order.customer_name ||
  //             order.user?.name ||
  //             order.customer?.name ||
  //             "Unknown",
  //           email: order.customer_email || order.user?.email || "-",
  //           paymentMethod: order.payment_method?.toUpperCase() || "POINTS",
  //           items: order.items ?? order.order_items ?? [],
  //           subtotal: formatMoney(order.subtotal || 0),
  //           tax: formatMoney(order.tax_amount || 0),
  //           shipping: formatMoney(order.shipping_amount || 0),
  //           discount: formatMoney(order.discount_amount || 0),
  //           notes: order.notes,
  //           createdAt: order.created_at,
  //         }));
  //         setTableData(rows);

  //         // Update pagination total
  //         setPagination((prev) => ({
  //           ...prev,
  //           total: rows.length,
  //           current: 1,
  //         }));

  //         if (!rows.length) {
  //           setErrorMessage("No invoices found.");
  //         }
  //         setLoading(false);
  //       },
  //       onError: (err) => {
  //         console.error("Invoices fetch error:", err);
  //         setErrorMessage(
  //           err?.response?.data?.message ||
  //             err?.message ||
  //             "Failed to load invoices.",
  //         );
  //         setLoading(false);
  //       },
  //     });
  //   };
  // decrypted
  const fetchInvoices = () => {
    setLoading(true);
    request({
      url: apiPath.orders,
      method: "GET",
      onSuccess: async (response) => {
        const rawOrders = normalizePayload(response);

        const orders = await Promise.all(
          rawOrders.map(async (order) => {
            let merged = order;

            // order-level secure -> merges onto order itself
            if (order.secure) {
              try {
                merged = await mergeDecrypted(order);
              } catch (err) {
                console.error(`Failed to decrypt order id=${order.id}:`, err);
              }
            }

            // user-level secure -> merges onto merged.user
            if (merged.user?.secure) {
              try {
                const decryptedUser = await mergeDecrypted(merged.user);
                merged = { ...merged, user: decryptedUser };
              } catch (err) {
                console.error(
                  `Failed to decrypt user for order id=${order.id}:`,
                  err,
                );
              }
            }

            return merged;
          }),
        );

        console.log(orders);

        // Calculate summary statistics
        const totalInvoices = orders.length;
        const totalRevenue = orders.reduce((sum, order) => {
          const amount = Number(
            order.total_amount ??
              order.grand_total ??
              order.total ??
              order.amount ??
              order.subtotal ??
              0,
          );
          return sum + amount;
        }, 0);

        const paidInvoices = orders.filter((order) => {
          const status = (
            order.status ||
            order.order_status ||
            order.payment_status ||
            ""
          ).toLowerCase();
          return (
            status === "paid" ||
            status === "completed" ||
            status === "delivered"
          );
        }).length;

        const pendingInvoices = orders.filter((order) => {
          const status = (
            order.status ||
            order.order_status ||
            order.payment_status ||
            ""
          ).toLowerCase();
          return status === "pending" || status === "processing";
        }).length;

        setSummary({
          total_invoices: totalInvoices,
          total_revenue: totalRevenue,
          paid: paidInvoices,
          pending: pendingInvoices,
        });

        const rows = orders.map((order, index) => ({
          key: order.id ?? order.order_number ?? index,
          originalIndex: index,
          id: order.id ?? order.order_number ?? index + 1,
          orderId: order.order_number ?? order.id ?? `#${index + 1}`,
          grandTotal: formatMoney(
            order.total_amount ??
              order.grand_total ??
              order.total ??
              order.amount ??
              order.subtotal ??
              0,
          ),
          status:
            order.status ||
            order.order_status ||
            order.payment_status ||
            "Pending",
          orderDate: formatDate(
            order.created_at || order.order_date || order.date,
          ),
          customerName:
            order.customer_name ||
            order.user?.name ||
            order.customer?.name ||
            "Unknown",
          email: order.customer_email || order.user?.email || "-",
          paymentMethod: order.payment_method?.toUpperCase() || "POINTS",
          items: order.items ?? order.order_items ?? [],
          subtotal: formatMoney(order.subtotal || 0),
          tax: formatMoney(order.tax_amount || 0),
          shipping: formatMoney(order.shipping_amount || 0),
          discount: formatMoney(order.discount_amount || 0),
          notes: order.notes,
          createdAt: order.created_at,
        }));
        console.log(rows);
        setTableData(rows);

        // Update pagination total
        setPagination((prev) => ({
          ...prev,
          total: rows.length,
          current: 1,
        }));

        if (!rows.length) {
          setErrorMessage("No invoices found.");
        }
        setLoading(false);
      },
      onError: (err) => {
        console.error("Invoices fetch error:", err);
        setErrorMessage(
          err?.response?.data?.message ||
            err?.message ||
            "Failed to load invoices.",
        );
        setLoading(false);
      },
    });
  };

  const handleViewDetails = (record) => {
    setSelectedInvoice(record);
    setModalVisible(true);
  };

  // Filter invoices based on search
  const filteredData = searchText
    ? tableData.filter(
        (invoice) =>
          invoice.orderId?.toLowerCase().includes(searchText.toLowerCase()) ||
          invoice.customerName
            ?.toLowerCase()
            .includes(searchText.toLowerCase()) ||
          invoice.email?.toLowerCase().includes(searchText.toLowerCase()) ||
          invoice.orderId?.includes(searchText),
      )
    : tableData;

  // Update pagination total when filter changes
  useEffect(() => {
    setPagination((prev) => ({
      ...prev,
      total: filteredData.length,
      current: 1,
    }));
  }, [searchText]);

  // Get current page data
  const getCurrentPageData = () => {
    const start = (pagination.current - 1) * pagination.pageSize;
    const end = start + pagination.pageSize;
    return filteredData.slice(start, end).map((item, index) => ({
      ...item,
      srNo: start + index + 1,
    }));
  };

  const handleTableChange = (newPagination) => {
    setPagination({
      current: newPagination.current,
      pageSize: newPagination.pageSize,
      total: filteredData.length,
    });
  };

  // Export to CSV with improved formatting
  const handleExport = () => {
    const exportData = filteredData.map((invoice, index) => ({
      "SR No.": index + 1,
      "Invoice ID": invoice.orderId,
      "Customer Name": invoice.customerName,
      Email: invoice.email,
      "Grand Total (Points)": invoice.grandTotal,
      Status: getStatusText(invoice.status),
      "Payment Method": invoice.paymentMethod,
      "Order Date": invoice.orderDate,
      Subtotal: invoice.subtotal,
      Tax: invoice.tax,
      Shipping: invoice.shipping,
      Discount: invoice.discount,
      Notes: invoice.notes || "-",
    }));

    const csv = convertToCSV(exportData);
    // Add BOM for UTF-8 to handle special characters
    const blob = new Blob(["\uFEFF" + csv], {
      type: "text/csv;charset=utf-8;",
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    const timestamp = new Date()
      .toISOString()
      .replace(/[:.]/g, "-")
      .slice(0, 19);
    a.href = url;
    a.download = `invoices_export_${timestamp}.csv`;
    a.click();
    window.URL.revokeObjectURL(url);

    message.success(`${exportData.length} invoices exported successfully`);
  };

  const convertToCSV = (data) => {
    if (!data || data.length === 0) return "";

    const headers = Object.keys(data[0]);
    const csvRows = [];

    csvRows.push(headers.join(","));

    for (const row of data) {
      const values = headers.map((header) => {
        let value = row[header] || "";
        // Convert to string and escape quotes
        value = String(value);
        if (
          value.includes(",") ||
          value.includes('"') ||
          value.includes("\n")
        ) {
          value = `"${value.replace(/"/g, '""')}"`;
        }
        return value;
      });
      csvRows.push(values.join(","));
    }

    return csvRows.join("\n");
  };

  const columns = [
    {
      title: "SR No.",
      dataIndex: "srNo",
      key: "srNo",
      width: 70,
      fixed: "left",
      render: (text) => (
        <Text style={{ color: "#64748b", fontWeight: 500 }}>{text}</Text>
      ),
    },
    {
      title: "Invoice ID",
      dataIndex: "orderId",
      key: "orderId",
      width: 200,
      fixed: "left",
      render: (text, record) => (
        <div>
          <Text strong style={{ color: "#0f172a", fontSize: "13px" }}>
            {text}
          </Text>
          <div style={{ fontSize: "11px", color: "#94a3b8", marginTop: "2px" }}>
            ID: {record.id}
          </div>
        </div>
      ),
    },
    {
      title: "Customer",
      dataIndex: "customerName",
      key: "customerName",
      width: 180,
      render: (text, record) => (
        <div>
          <Text style={{ color: "#334155", fontSize: "13px", fontWeight: 500 }}>
            {text}
          </Text>
          <div style={{ fontSize: "12px", color: "#64748b" }}>
            {record.email}
          </div>
        </div>
      ),
    },
    {
      title: "Grand Total",
      dataIndex: "grandTotal",
      key: "grandTotal",
      width: 120,
      align: "right",
      render: (text) => (
        <Text strong style={{ color: "#0f172a", fontSize: "14px" }}>
          {text} pts
        </Text>
      ),
    },
    {
      title: "Payment Method",
      dataIndex: "paymentMethod",
      key: "paymentMethod",
      width: 120,
      render: (text) => (
        <Tag color="purple" style={{ borderRadius: "4px" }}>
          {text}
        </Tag>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 110,
      render: (status) => (
        <Tag
          style={{
            borderRadius: "12px",
            border: "none",
            fontWeight: 500,
            padding: "2px 12px",
            background: getStatusColor(status),
            color: "#fff",
            fontSize: "12px",
          }}
        >
          {getStatusText(status)}
        </Tag>
      ),
    },
    {
      title: "Order Date",
      dataIndex: "orderDate",
      key: "orderDate",
      width: 160,
      render: (text) => (
        <Text style={{ color: "#64748b", fontSize: "13px" }}>{text}</Text>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      width: 80,
      fixed: "right",
      align: "center",
      render: (_, record) => (
        <Tooltip title="View Details">
          <Button
            type="text"
            icon={<Eye size={18} style={{ color: "#2563eb" }} />}
            onClick={(e) => {
              e.stopPropagation();
              handleViewDetails(record);
            }}
          />
        </Tooltip>
      ),
    },
  ];

  return (
    <div
      className="invoices-container"
      style={{
        padding: "24px",
        background: "#fff",
        minHeight: "100vh",
        borderRadius: "10px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "24px",
        }}
      >
        <Title
          level={3}
          style={{ margin: 0, color: "#0f172a", fontWeight: 700 }}
        >
          Invoices
        </Title>
        <Button
          icon={<Upload size={16} />}
          onClick={handleExport}
          style={{
            display: "flex",
            alignItems: "center",
            borderRadius: "6px",
            color: "#64748b",
            fontWeight: 500,
          }}
          disabled={filteredData.length === 0}
        >
          Export {filteredData.length > 0 && `(${filteredData.length})`}
        </Button>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "24px",
        }}
      >
        <Input
          placeholder="Search by Invoice ID, Customer or Email"
          prefix={<Search size={16} color="#94a3b8" />}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          style={{ width: 350, borderRadius: "8px" }}
          allowClear
          size="large"
        />
        <div>
          <Text type="secondary">
            Showing {filteredData.length} of {tableData.length} invoices
          </Text>
        </div>
      </div>

      {errorMessage && (
        <Alert
          type="error"
          message="Invoices load error"
          description={errorMessage}
          showIcon
          style={{ marginBottom: 16 }}
        />
      )}

      {summary && (
        <Row gutter={16} style={{ marginBottom: 24 }}>
          <Col span={24} md={12} xl={6}>
            <Card
              bordered
              style={{
                borderRadius: 12,
                boxShadow: "0 1px 2px 0 rgba(0,0,0,0.05)",
              }}
            >
              <Text style={{ color: "#64748b", fontSize: "14px" }}>
                Total Invoices
              </Text>
              <div
                style={{
                  marginTop: 8,
                  fontSize: 28,
                  fontWeight: 700,
                  color: "#0f172a",
                }}
              >
                {summary.total_invoices}
              </div>
            </Card>
          </Col>
          <Col span={24} md={12} xl={6}>
            <Card
              bordered
              style={{
                borderRadius: 12,
                boxShadow: "0 1px 2px 0 rgba(0,0,0,0.05)",
              }}
            >
              <Text style={{ color: "#64748b", fontSize: "14px" }}>
                Total Revenue
              </Text>
              <div
                style={{
                  marginTop: 8,
                  fontSize: 28,
                  fontWeight: 700,
                  color: "#8b5cf6",
                }}
              >
                {summary.total_revenue.toFixed(2)} pts
              </div>
            </Card>
          </Col>
          <Col span={24} md={12} xl={6}>
            <Card
              bordered
              style={{
                borderRadius: 12,
                boxShadow: "0 1px 2px 0 rgba(0,0,0,0.05)",
              }}
            >
              <Text style={{ color: "#64748b", fontSize: "14px" }}>
                Paid Invoices
              </Text>
              <div
                style={{
                  marginTop: 8,
                  fontSize: 28,
                  fontWeight: 700,
                  color: "#10b981",
                }}
              >
                {summary.paid}
              </div>
            </Card>
          </Col>
          <Col span={24} md={12} xl={6}>
            <Card
              bordered
              style={{
                borderRadius: 12,
                boxShadow: "0 1px 2px 0 rgba(0,0,0,0.05)",
              }}
            >
              <Text style={{ color: "#64748b", fontSize: "14px" }}>
                Pending Invoices
              </Text>
              <div
                style={{
                  marginTop: 8,
                  fontSize: 28,
                  fontWeight: 700,
                  color: "#f59e0b",
                }}
              >
                {summary.pending}
              </div>
            </Card>
          </Col>
        </Row>
      )}

      <Table
        scroll={{ x: "max-content" }}
        columns={columns}
        dataSource={getCurrentPageData()}
        loading={loading}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: filteredData.length,
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} of ${total} invoices`,
          showSizeChanger: true,
          showQuickJumper: true,
          pageSizeOptions: ["10", "20", "50", "100", "200"],
        }}
        onChange={handleTableChange}
        style={{
          border: "1px solid #e2e8f0",
          borderRadius: "12px",
          overflow: "hidden",
        }}
        className="invoice-table-custom"
        rowClassName={() => "invoice-table-row"}
        locale={{ emptyText: errorMessage || "No invoices found" }}
        onRow={(record) => ({
          onClick: () => navigate(`/sales/invoices/${record.id}`),
        })}
      />

      {/* Invoice Details Modal - Keep the same */}
      <Modal
        title={
          <div>
            <Text strong style={{ fontSize: "18px" }}>
              Invoice Details
            </Text>
            <div
              style={{ fontSize: "14px", color: "#64748b", marginTop: "4px" }}
            >
              Invoice #{selectedInvoice?.orderId}
            </div>
          </div>
        }
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={[
          <Button key="close" onClick={() => setModalVisible(false)}>
            Close
          </Button>,
        ]}
        width={800}
      >
        {selectedInvoice && (
          <div>
            <Row gutter={16} style={{ marginBottom: 24 }}>
              <Col span={12}>
                <Card size="small" title="Invoice Information">
                  <div>
                    <strong>SR No.:</strong> {selectedInvoice.srNo}
                  </div>
                  <div>
                    <strong>Invoice ID:</strong> {selectedInvoice.orderId}
                  </div>
                  <div>
                    <strong>Status:</strong>
                    <Tag
                      style={{
                        marginLeft: 8,
                        borderRadius: "12px",
                        background: getStatusColor(selectedInvoice.status),
                        color: "#fff",
                        border: "none",
                      }}
                    >
                      {getStatusText(selectedInvoice.status)}
                    </Tag>
                  </div>
                  <div>
                    <strong>Order Date:</strong> {selectedInvoice.orderDate}
                  </div>
                  <div>
                    <strong>Payment Method:</strong>{" "}
                    {selectedInvoice.paymentMethod}
                  </div>
                  {selectedInvoice.notes && (
                    <div>
                      <strong>Notes:</strong> {selectedInvoice.notes}
                    </div>
                  )}
                </Card>
              </Col>
              <Col span={12}>
                <Card size="small" title="Customer Information">
                  <div>
                    <strong>Name:</strong> {selectedInvoice.customerName}
                  </div>
                  <div>
                    <strong>Email:</strong> {selectedInvoice.email}
                  </div>
                </Card>
              </Col>
            </Row>

            <Card
              size="small"
              title="Invoice Summary"
              style={{ marginBottom: 24 }}
            >
              <Row gutter={16}>
                <Col span={12}>
                  <div>
                    <strong>Subtotal:</strong> {selectedInvoice.subtotal} pts
                  </div>
                  <div>
                    <strong>Tax:</strong> {selectedInvoice.tax} pts
                  </div>
                </Col>
                <Col span={12}>
                  <div>
                    <strong>Shipping:</strong> {selectedInvoice.shipping} pts
                  </div>
                  <div>
                    <strong>Discount:</strong> {selectedInvoice.discount} pts
                  </div>
                </Col>
              </Row>
              <div
                style={{
                  marginTop: 16,
                  paddingTop: 16,
                  borderTop: "1px solid #e2e8f0",
                }}
              >
                <div>
                  <strong>Grand Total:</strong>{" "}
                  <span
                    style={{
                      fontSize: "18px",
                      fontWeight: 700,
                      color: "#8b5cf6",
                    }}
                  >
                    {selectedInvoice.grandTotal} pts
                  </span>
                </div>
              </div>
            </Card>

            {selectedInvoice.items && selectedInvoice.items.length > 0 && (
              <Card size="small" title="Invoice Items">
                <Table
                  dataSource={selectedInvoice.items}
                  pagination={false}
                  size="small"
                  columns={[
                    {
                      title: "SR No.",
                      key: "srNo",
                      width: 70,
                      render: (_, __, index) => index + 1,
                    },
                    {
                      title: "Product Name",
                      dataIndex: "product_name",
                      key: "product_name",
                      render: (text) => text || "Product",
                    },
                    {
                      title: "Quantity",
                      dataIndex: "quantity",
                      key: "quantity",
                      width: 100,
                      align: "center",
                      render: (quantity) => quantity || 1,
                    },
                    {
                      title: "Unit Price",
                      key: "unit_price",
                      width: 120,
                      align: "right",
                      render: (_, record) => {
                        // Calculate unit price by dividing line_total by quantity
                        const lineTotal = Number(record.line_total || 0);
                        const quantity = Number(record.quantity || 1);
                        const unitPrice = lineTotal / quantity;
                        return `${unitPrice.toFixed(2)} pts`;
                      },
                    },
                    {
                      title: "Total",
                      dataIndex: "line_total",
                      key: "line_total",
                      width: 120,
                      align: "right",
                      render: (lineTotal) => {
                        const total = Number(lineTotal || 0);
                        return `${total.toFixed(2)} pts`;
                      },
                    },
                  ]}
                  rowKey="id"
                />
              </Card>
            )}
          </div>
        )}
      </Modal>

      <style jsx>{`
        .invoice-table-row {
          cursor: pointer;
          transition: background 0.3s;
        }
        .invoice-table-row:hover {
          background: #f8fafc;
        }
      `}</style>
    </div>
  );
};

export default InvoicePage;
